module.exports = __webpack_public_path__ + "img/one_future.9665a027.webp";